import React, { Component } from "react";
import { Images } from "../../components";
export class LoadingImg extends Component {
  render() {
    return (
      <div style={{height: "100vh", width: "100vw", backgroundColor: "#13274B" }}>
        <img
          style={{ height:"70%" ,width:"100%" , position:"absolute" , top:"12%"}}
          src={Images.LoadingBackground}
        />
        <div
          style={{
            height: "170px",
            width: "30%",
            position: "absolute",
            left: "33%",
            top: "50%",
          }}
        >
          <div className="events">
            <div className="lds-parent-ring">
              <div class="lds-ring">
                <div />
                <div />
                <div />
                <div />
              </div>
            </div>
            <div style={{textAlign:"center"}}>
                <span style={{color:"white"}}>Loading...</span>
            </div>
          </div>
        </div>

        <img
          style={{
            height: "70px",
            width: "30%",
            position: "absolute",
            left: "33%",
            top: "30%",
          }}
          alt="Winners"
          src={Images.LogoWinners}
        />
      </div>
    );
  }
}

export default LoadingImg;
